import { render, staticRenderFns } from "./PrivateHistory.vue?vue&type=template&id=9c3b3b86&scoped=true"
var script = {}
import style0 from "./PrivateHistory.vue?vue&type=style&index=0&id=9c3b3b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3b3b86",
  null
  
)

export default component.exports